(function () {
  'use strict';

  const dataEl = document.getElementById('ProductGalleryData');
  if (!dataEl) return;

  let galleryData;
  try { galleryData = JSON.parse(dataEl.textContent); } catch (e) { return; }

  const sectionId = galleryData.sectionId;
  if (!sectionId || galleryData.hasColorOption === -1) return;

  const mainSliderList  = document.getElementById(`Slider-Gallery-${sectionId}`);
  const thumbList       = document.getElementById(`Slider-Thumbnails-${sectionId}`);
  const mainSliderComp  = mainSliderList?.closest('slider-component');
  const thumbSliderComp = thumbList?.closest('slider-component');
  const hiddenInput     = document.querySelector(
    `#product-form-${sectionId} input[name="id"], form[id*="${sectionId}"] input[name="id"]`
  );

  if (!mainSliderList || !hiddenInput) return;

  let lastVariantId = null;

  // ── variant -> color ─────────────────────────────────────────
  function getColor(variantId) {
    const v = galleryData.variants.find(v => v.id === parseInt(variantId, 10));
    return v?.color ? String(v.color).toLowerCase().trim() : null;
  }

  // ── variant -> size（无尺码选项时返回 null）──────────────────
  function getSize(variantId) {
    if (!galleryData.sizeOptionIndex || galleryData.sizeOptionIndex === -1) return null;
    const v = galleryData.variants.find(v => v.id === parseInt(variantId, 10));
    return v?.size ? String(v.size).toLowerCase().trim() : null;
  }

  // ── 按颜色打 vg-hidden class（主图 + 缩略图）────────────────
  // CSS 需定义：.vg-hidden { position:absolute!important; width:1px!important;
  //   height:1px!important; overflow:hidden!important; opacity:0!important;
  //   pointer-events:none!important; }

  function applyVisibility(color) {
    [
      { list: mainSliderList, sel: 'li.product__media-item'  },
      { list: thumbList,      sel: 'li.thumbnail-list__item' },
    ].forEach(({ list, sel }) => {
      if (!list) return;
      list.querySelectorAll(sel).forEach(li => {
        const group = (li.dataset.alt || '').toLowerCase().trim();
        const show  = !group || group === color || group === 'common';
        li.classList.toggle('vg-hidden', !show);
      });
    });
  }

  // ── 更新主图计数器 ───────────────────────────────────────────
  function updateCounter() {
    if (!mainSliderComp) return;
    const n = [...mainSliderList.querySelectorAll('li.product__media-item')]
      .filter(li => !li.classList.contains('vg-hidden')).length;
    const t = mainSliderComp.querySelector('.slider-counter--total');
    const c = mainSliderComp.querySelector('.slider-counter--current');
    if (t) t.textContent = n || 1;
    if (c) c.textContent = '1';
  }

  // ── 重算 slider + 跳到目标图 ────────────────────────────────
  function afterFilter(variantId) {
    const size = getSize(variantId);

    requestAnimationFrame(() => {
      // 强制 slider 用当前 DOM 顺序重建 sliderItems（防止 offsetLeft 错序）
      if (mainSliderComp && 'sliderItems' in mainSliderComp) {
        mainSliderComp.sliderItems = Array.from(
          mainSliderComp.slider.querySelectorAll('li')
        );
      }
      if (thumbSliderComp && 'sliderItems' in thumbSliderComp) {
        thumbSliderComp.sliderItems = Array.from(
          thumbSliderComp.slider.querySelectorAll('li')
        );
      }

      mainSliderComp?.initPages?.();
      thumbSliderComp?.initPages?.();
      updateCounter();
      thumbList?.scrollTo({ left: 0 });

      // 在 callback 内动态获取，确保 custom element 已初始化
      const gallery = document.querySelector(`#MediaGallery-${sectionId}`);
      if (typeof gallery?.setActiveMedia === 'function') {

        const visibleItems = [...mainSliderList.querySelectorAll('li.product__media-item')]
          .filter(li => !li.classList.contains('vg-hidden'));

        // 优先：data-size 匹配当前尺码的图片
        // 退回：当前颜色组第一张可见图
        const target = (size && visibleItems.find(li =>
          (li.dataset.size || '').toLowerCase().trim() === size
        )) || visibleItems[0];

        if (target) gallery.setActiveMedia(target.dataset.mediaId, true);
      }
    });
  }

  // ── 变体切换处理（去重，无 debounce）────────────────────────
  function handleVariantChange() {
    const id = hiddenInput.value;
    if (!id || String(id) === String(lastVariantId)) return;
    lastVariantId = String(id);

    const color = getColor(id);
    if (!color) return;

    applyVisibility(color);  // 同步打 class
    afterFilter(id);         // rAF 内重算 + 跳图
  }

  // ── 多版本 Dawn 监听 ─────────────────────────────────────────
  document.addEventListener('variant:changed', handleVariantChange);
  document.addEventListener('variant:change',  handleVariantChange);
  hiddenInput.addEventListener('change',       handleVariantChange);
  window.addEventListener('popstate',          handleVariantChange);

  // ── 首次加载：双层 rAF 等 Dawn 自身初始化完成 ────────────────
  const initialId = window.__selectedVariantId || hiddenInput.value;
  if (initialId) {
    lastVariantId = String(initialId);
    const color = getColor(initialId);
    if (color) {
      requestAnimationFrame(() => requestAnimationFrame(() => {
        applyVisibility(color);
        afterFilter(initialId);
      }));
    }
  }
})();